/* eslint-disable react/prop-types */
import {
  Form,
  Modal,
  Row,
  Spin,
} from 'antd';
import { getHistoricosNombramientos } from 'api/catalogos/HistoricoNombramientos';
import { getHistoricosMovimientosEmpleados } from 'api/nominas/historicoMovimientosEmpleados';
import http from 'api/reporteador';
import { checkToken } from 'api/utils';
import Dragger from 'components/Dragger';
import FormSubmitControls from 'components/FormSubmitControls';
import Table from 'components/Table';
import currencyFormatter from 'utils/currencyFormatter';
import React, { useEffect, useState } from 'react';
import HTTP, { baseURL } from 'utils/api';
import { ESTATUS_ACTIVO } from 'utils/constants';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import { getModelPermission } from 'utils/permission';

export const HistoricoMovimientoEmpleadoPermission = {
  permissionModel: 'historicomovimientoempleado',
  catalogsModels: [],
  tabsModels: [],
};

const baseURI = 'nominas/movimientos-empleados-importar-excel';

const ExpedienteNombramientos = ({
  currentEmpleado,
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [formCarga] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pageActual, setPageActual] = useState(1);

  const getPermission = getModelPermission(
    HistoricoMovimientoEmpleadoPermission.permissionModel,
    HistoricoMovimientoEmpleadoPermission.catalogsModels,
    HistoricoMovimientoEmpleadoPermission.tabsModels,
    false,
  );

  const fetchData = async () => {
    if (!currentEmpleado) return;

    setLoading(true);
    try {
      const response = await getHistoricosNombramientos({ empleado: currentEmpleado });
      let { results } = response;

      // Ordenar: activos primero
      results = results.sort((a, b) => {
        // eslint-disable-next-line max-len
        if (a.estados_globales === ESTATUS_ACTIVO && b.estados_globales !== ESTATUS_ACTIVO) return -1;
        // eslint-disable-next-line max-len
        if (a.estados_globales !== ESTATUS_ACTIVO && b.estados_globales === ESTATUS_ACTIVO) return 1;
        return 0;
      });

      setData({ ...response, results });
    } catch (err) {
      onError(err);
    }
    setLoading(false);
  };

  const baseURI2 = '/nominas/historico-nombramientos';
  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, '')); // solo dígitos
      const response = await HTTP.get(baseURI2, { params: { page: cleanPage, ...q } });

      const { results } = response.data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ...response.data, results });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _data,
      ] = await Promise.all([
        getHistoricosNombramientos({ empleado: currentEmpleado }),
      ]);
      const { results } = _data;
      if (mounted) {
        setData({ ..._data, results });
        setLoading(false);
      }
    };
    if (currentEmpleado) {
      fetchAll();
    } else {
      setData([]);
      setLoading(false);
    }
    return () => { mounted = false; };
  }, [currentEmpleado]);

  const onCancel = () => {
    setVisibleModal(false);
    formCarga.resetFields();
  };

  // const onClickObtenerPlantilla = async () => {
  //   try {
  //     setLoading(true);
  //     const excel = await getHistoricoMovimientosEmpleadosPlantilla();
  //     if (excel) {
  //       const blob = new Blob([excel], {
  //         type: 'application/ms-excel',
  //       });
  //       const url = URL.createObjectURL(blob);
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.download = 'HistoricoMovimientoEmpleado_Plantilla.xlsx';
  //       link.click();
  //     }
  //     setLoading(false);
  //   } catch (err) {
  //     onError(err);
  //   }
  // };

  // const onClickCargar = () => {
  //   setVisibleModal(true);
  // };

  const onUpload = async () => {
    try {
      await formCarga.validateFields();
      const { file } = formCarga.getFieldsValue();
      if (file) {
        setLoading(true);
        const formData = new FormData();
        formData.append('archivo', file.file);
        const uri = baseURI.at(-1) === '/' ? baseURI : `${baseURI}/`;
        const response = await HTTP.post(`${baseURL}${uri}`, formData, {
          headers: {
            'Content-Type': 'application/ms-excel',
          },
          responseType: 'arraybuffer',
        });
        if (response?.data) {
          const blob = new Blob([response?.data], {
            type: 'application/ms-excel',
          });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'HistoricoMovimientoEmpleado_Respuesta.xlsx';
          link.click();
        }
        if (response?.status === 200) {
          onSuccess(response, 'Operación realizada correctamente', 5);
          await fetchData();
          onCancel();
        }
      }
      setLoading(false);
      setVisibleModal(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // const menuImport = (
  //   <Menu
  //     items={[
  //       {
  //         key: 1,
  //         label: 'Obtener Plantilla',
  //         text: 'Obtener Plantilla',
  //         icon: <FileExcelOutlined />,
  //         onClick: () => onClickObtenerPlantilla(),
  //       },
  //       {
  //         key: 2,
  //         label: 'Cargar',
  //         text: 'Cargar',
  //         icon: <DownloadOutlined />,
  //         onClick: () => onClickCargar(),
  //       },
  //     ]}
  //   />
  // );

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  const columns = [
    {
      titleText: 'Fecha de Emisión',
      dataIndex: 'fecha_de_emision',
      key: 'fecha_de_emision',
      width: 200,
    },
    {
      titleText: 'Folio de Nombramiento',
      dataIndex: 'folio',
      key: 'folio',
      width: 200,
    },
    {
      titleText: 'Carácter de Nombramiento',
      dataIndex: 'descripcion_caracter_de_nombramiento',
      key: 'descripcion_caracter_de_nombramiento',
      width: 250,
    },
    {
      titleText: 'Inicio de Vigencia',
      dataIndex: 'inicio_vigencia',
      key: 'inicio_vigencia',
      width: 200,
    },
    {
      titleText: 'Término de Vigencia',
      dataIndex: 'termino_de_vigencia',
      key: 'termino_de_vigencia',
      width: 200,
    },
    {
      titleText: 'Fecha de Baja',
      dataIndex: 'fecha_baja',
      key: 'fecha_baja',
      width: 200,
    },
    {
      titleText: 'Motivo de Baja',
      dataIndex: 'descripcion_motivo_baja_nombramiento',
      key: 'descripcion_motivo_baja_nombramiento',
      width: 250,
    },
    {
      titleText: 'Estatus del Nombramiento',
      dataIndex: 'descripcion_estado_de_nombramiento',
      key: 'descripcion_estado_de_nombramiento',
      width: 250,
    },
    {
      titleText: 'Plaza',
      dataIndex: 'descripcion_plaza',
      key: 'descripcion_plaza',
      width: 250,
    },
    {
      titleText: 'Área',
      dataIndex: 'descripcion_directorio_de_area',
      key: 'descripcion_directorio_de_area',
      width: 250,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto', // si necesitas el nombre del puesto, asegúrate que venga en la respuesta o haz un join en backend
      key: 'puesto',
      width: 150,
    },
    {
      titleText: 'Tipo de Empleado',
      dataIndex: 'descripcion_tipo_de_empleado',
      key: 'descripcion_tipo_de_empleado',
      width: 200,
    },
    {
      titleText: 'Sueldo Mensual',
      dataIndex: 'sueldo_mensual',
      key: 'sueldo_mensual',
      width: 200,
      align: 'right',
      render: (value) => currencyFormatter(value),
    },
    {
      titleText: 'Prestaciones',
      dataIndex: 'prestaciones_para_nombramiento',
      key: 'prestaciones_para_nombramiento',
      width: 300,
      render: (prestaciones) => (Array.isArray(prestaciones) && prestaciones.length
        ? prestaciones.map((p) => p.descripcion).join(', ')
        : 'Sin prestaciones'),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={Array.isArray(data?.results) ? data.results : []}
          pagination={false}
          paginationCallback={fetchPaginated}
          count={data?.count || 0}
          permission={getPermission}
        // allowCustomImport
        // customImportMenu={menuImport}
        // customImportText="Importar Movimientos Empleados"
        // allowExportPDF={false}
        // loading={loading}
        />
        <Modal
          open={visibleModal}
          title={(
            <FormSubmitControls
              label="Carga Masiva"
              onFinish={onUpload}
              onCancel={onCancel}
              loading={loading}
            />
          )}
          onCancel={onCancel}
          footer={null}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          forceRender
          destroyOnClose
        >
          <Spin tip="Cargando..." spinning={loading}>
            <Form
              layout="vertical"
              form={formCarga}
              name="carga"
              onFinish={onUpload}
            >
              <Dragger
                label="Archivo"
                limitMB={30}
                rules={rules.required}
                name="file"
                allowedExtensions={['xlsx']}
              />
            </Form>
          </Spin>
        </Modal>
      </Spin>
    </Row>
  );
};

export default ExpedienteNombramientos;
